<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
  components: {
    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: 'Arial';
}
a{
  text-decoration: none;
}
.text_color{
  color: #272443;
}
.pt-10{
  padding-top: 10px;
}
.pt-20{
  padding-top: 20px;
}
.pt-30{
  padding-top: 30px;
}
.pt-40{
  padding-top: 40px;
}
.pb-10{
  padding-bottom: 10px;
}
.pb-20{
  padding-bottom: 20px;
}
.pb-30{
  padding-bottom: 30px;
}
.pb-40{
  padding-bottom: 40px;
}
.white{
  color: #fff;
}
.c9{
  color: #999;
}
.c6{
  color: #666;
}
.c3{
  color: #333;
}
</style>
